var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTooltip',{attrs:{"text":_vm._tooltipText,"position":"up","extraClass":("v-time-tooltip " + (_vm.noPadding ? 'no-pad' : ''))}},[_c('span',_vm._g({class:( _obj = {}, _obj['clickable'] = _vm.onClick, _obj )},_vm.onClick ? { click: _vm.onClick } : {}),[_vm._v("\n    "+_vm._s(_vm._textToDisplay)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }